export const FALLBACK_CENTER_LAT = 43.6532;
export const FALLBACK_CENTER_LON = -79.3832;

export function computeZoomForRadius(radiusKm, latitude) {
  const rKm = Math.max(0.5, Number(radiusKm) || 1);
  const lat = typeof latitude === "number" ? latitude : FALLBACK_CENTER_LAT;

  const mapWidthPx = 900;
  const radiusMeters = rKm * 1000;
  const metersPerPixel = (2 * radiusMeters) / mapWidthPx;

  const equatorLength = 40075016.686;
  const latRad = (Math.PI * lat) / 180;

  const zoom = Math.log2(
    (equatorLength * Math.cos(latRad)) / (metersPerPixel * 256)
  );

  const clamped = Math.max(2, Math.min(18, zoom));
  return Math.round(clamped);
}
